import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import JoinForm from "../components/JoinForm";
import { API_BASE_URL } from "../api/client";

export default function JoinPage() {
  const navigate = useNavigate();
  const [done, setDone] = useState(false);

  return (
    <div className="auth-screen">
      <div className="brand">
        <img src="/onetak-icon.svg" alt="onetak" className="brand-icon" />
        <div className="brand-mark">one<span>tak</span></div>
      </div>
      {!done ? (
        <JoinForm apiBaseUrl={API_BASE_URL} onJoinSuccess={() => setDone(true)} onGoLogin={() => navigate("/login")} />
      ) : (
        <div className="auth-form join-done">
          <div className="check">✓</div>
          <h2>가입 완료!</h2>
          <p>회원가입이 완료되었습니다. 로그인해주세요.</p>
          <button type="submit" onClick={() => navigate("/login")}>로그인하러 가기</button>
        </div>
      )}
    </div>
  );
}
